import { Audio } from 'expo-av'

export const playSound = async (source) => {
  try {
    const sound = new Audio.Sound()

    const onPlaybackStatusUpdate = playbackStatus => {
      if (playbackStatus.didJustFinish && !playbackStatus.isLooping) {
        sound.unloadAsync()
      }
    }

    sound.setOnPlaybackStatusUpdate(onPlaybackStatusUpdate)
    await sound.loadAsync(source)
    await sound.playAsync()
  } catch (error) {
    console.error('Error playing sound', error)
  }
}
